import { Component } from '@angular/core';

@Component({
    selector: 'ifbp-reset-password-done',
    templateUrl: './reset-password-done.component.html',
    standalone: false
})
export class ResetPasswordDoneComponent { }
